import request from "@/utils/request";

// 列表
export const getMyFollowList = (params) => {
  return request.get("/api/mts-api/follow/myFollowList", {
    params,
  });
};

// 详情
export function getFollowDetail(id) {
  return request({
    url: "/api/mts-api/follow/" + id,
    method: "get",
  });
}

// 发布商品
export function publishGoods(data) {
  return request({
    url: "/api/mts-api/follow/publishGoods",
    method: "post",
    data: data,
  });
}

/**
 *  修改商品信息
 * @param {} goodsId 商品id
 */
export function getChangeGoodsRecordList(goodsId) {
  return request({
    url: "/api/mts-api/goods/change/record/list",
    method: "get",
    params: {
      goodsId,
    },
  });
}

// 修改商品信息
export function updateGoodsInfo(data) {
  return request({
    url: "/api/mts-api/goods/change/record/updateData",
    method: "post",
    data: data,
  });
}

// 修改商品信息
export function auditList(goodsId) {
  return request({
    url: "/api/mts-api/goods/change/record/audit/list?goodsId=" + goodsId,
    method: "get",
  });
}

// 修改商品信息
export function auditData(data) {
  return request({
    url: "/api/mts-api/goods/change/record/audit",
    method: "post",
    data: data,
  });
}

//修改公开订单-买家下单手机号
export const addBuyerPhone = (data) => {
  return request.post("/api/mts-api/goods/addBuyerPhone", data);
};